import { FC } from 'react'
import styled, { keyframes } from 'styled-components'
import { Avatar } from '../Avatar'
import { SpeechBalloon } from '../SpeechBalloon'
import { MessageItem } from '../../states/messageState'

type BotMessageListProps = {
  messageItem: MessageItem
}
export const BotMessageList: FC<BotMessageListProps> = (props) => {
  const { messageItem } = props

  return (
    <StyledFlexStart>
      <StyledBotMessageWrap>
        <StyledAvatarWrap>
          <StyledAvatarTransition>
            <Avatar size={40}></Avatar>
          </StyledAvatarTransition>
        </StyledAvatarWrap>
        <StyledColumnReverse>
          {messageItem.messages.map((message, index) => (
            <StyledSpeechBalloonWrap key={index}>
              <SpeechBalloon sender="bot" isLast={index === messageItem.messages.length - 1}>
                {message}
              </SpeechBalloon>
            </StyledSpeechBalloonWrap>
          ))}
        </StyledColumnReverse>
      </StyledBotMessageWrap>
    </StyledFlexStart>
  )
}

const StyledBotMessageWrap = styled.div`
  width: 75%;
  margin-bottom: 10px;
  align-self: flex-start;
  display: flex;
`
const StyledSpeechBalloonWrap = styled.div`
  margin-bottom: 10px;
  position: relative;
`
const StyledFlexStart = styled.div`
  align-self: flex-start;
  width: 100%;
`
const StyledColumnReverse = styled.div`
  align-self: flex-start;
  width: 100%;
  flex-direction: column;
  display: flex;
`

const anime = keyframes`
  0%{
    opacity: 0;
    transform: translateY(10px) 
  }
  40%{
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translateY(0) 
  }
`

const StyledAvatarWrap = styled.div`
  margin-bottom: 15px;
  position: relative;
  width: 60px;
  animation: ${anime} 0.4s;
`
const StyledAvatarTransition = styled.div`
  position: absolute;
  bottom: -5px;
  transition: 0.5s;
  margin-right: 15px;
`
